import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, ChevronDown } from 'lucide-react';
import AIIcon from './AIIcon';
import './Navbar.css';

const services = [
  { name: 'GEO', full: 'Generative Engine Optimization', path: '/services/geo' },
  { name: 'AEO', full: 'Answer Engine Optimization', path: '/services/aeo' },
  { name: 'AIO', full: 'AI Optimization', path: '/services/aio' },
  { name: 'CAO', full: 'Conversational AI Optimization', path: '/services/cao' },
  { name: 'LLMO', full: 'Large Language Model Optimization', path: '/services/llmo' },
  { name: 'GAIO', full: 'Generative AI Optimization', path: '/services/gaio' },
  { name: 'AISO', full: 'AI Search Optimization', path: '/services/aiso' },
  { name: 'SRO', full: 'Search Response Optimization', path: '/services/sro' },
  { name: 'QEO', full: 'Query Engine Optimization', path: '/services/qeo' },
  { name: 'GSO', full: 'Generative Search Optimization', path: '/services/gso' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    setServicesOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-inner">
        <Link to="/" className="navbar-logo">
          <span className="logo-icon"><AIIcon size={26} /></span>
          <div className="logo-text-group">
            <span className="logo-text">Rajesh <span className="gradient-text">R</span></span>
            <span className="logo-sub">AI Technology Specialist</span>
          </div>
        </Link>

        <div className="navbar-links">
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>Home</Link>
          
          <div className="nav-dropdown" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)}>
            <button className={`nav-link nav-dropdown-btn ${location.pathname.includes('/services') ? 'active' : ''}`}>
              Services <ChevronDown size={14} />
            </button>
            <AnimatePresence>
              {servicesOpen && (
                <motion.div
                  className="dropdown-menu"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  {services.map(s => (
                    <Link key={s.name} to={s.path} className="dropdown-item">
                      <span className="dropdown-badge">{s.name}</span>
                      <span className="dropdown-full">{s.full}</span>
                    </Link>
                  ))}
                  <Link to="/services" className="dropdown-all">View All Services →</Link>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <Link to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>About</Link>
          <Link to="/kerala-analysis" className={`nav-link ${location.pathname === '/kerala-analysis' ? 'active' : ''}`}>Kerala Market</Link>
          <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
        </div>

        <div className="navbar-cta">
          <a href="https://wa.me/917907038984?text=Hi%20Rajesh!%20I%20visited%20your%20website%20and%20I%E2%80%99d%20like%20a%20FREE%20AI%20visibility%20audit%20for%20my%20business.%20Please%20get%20in%20touch!" target="_blank" rel="noreferrer" className="btn-primary" style={{padding:'10px 20px',fontSize:'14px'}}>
            Get Free Audit
          </a>
        </div>

        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Link to="/" className="mobile-link">Home</Link>
            <button className="mobile-link" onClick={() => setServicesOpen(!servicesOpen)}>
              Services <ChevronDown size={14} />
            </button>
            {servicesOpen && (
              <div className="mobile-services">
                {services.map(s => (
                  <Link key={s.name} to={s.path} className="mobile-service-item">
                    <span className="dropdown-badge" style={{fontSize:'10px'}}>{s.name}</span> {s.full}
                  </Link>
                ))}
                <Link to="/services" className="mobile-service-item" style={{color:'var(--accent-cyan)'}}>View All →</Link>
              </div>
            )}
            <Link to="/about" className="mobile-link">About</Link>
            <Link to="/kerala-analysis" className="mobile-link">Kerala Market</Link>
            <Link to="/contact" className="mobile-link">Contact</Link>
            <a href="https://wa.me/917907038984?text=Hi%20Rajesh!%20I%20visited%20your%20website%20and%20I%E2%80%99d%20like%20a%20FREE%20AI%20visibility%20audit%20for%20my%20business.%20Please%20get%20in%20touch!" target="_blank" rel="noreferrer" className="btn-primary mobile-cta">
              Get Free Audit
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
